<template>
  <div class="monthly top-up-type">
    <slot name="txtBefore"></slot>
    <b-row class="headline" id="topup-tct-text-activation-summary">
      <b-col sm="" md="" class="txtHeader">
        <slot name="txtMonthlyHeader">Monatliche Aufladung</slot>
      </b-col>
      <b-col sm="" md="" class="change-link" v-if="changeBtn">
          <a @click.prevent="goToTopUpStep()" class="linkChange">ändern</a>
      </b-col>
    </b-row>
    <b-row class="top-up-content">
      <b-col sm="" md="" class="label">
        <slot name="txtTopUpAmount">Aufladebetrag:</slot>
      </b-col>
      <b-col sm="" md="" class="value">
        {{ price(topUpInfo.amount) }}
      </b-col>
    </b-row>
      <b-row class="desc">
        <b-col sm="" md="" class="txtMonthlyDesc">
          <dyn-slot :slot-data="slotData">
          <slot name="txtMonthlyDesc">
            <p>
              Jeweils am {{ topUpInfo.trigger }}. eines Monats wird der ausgewählte
              Aufladebetrag auf Dein mobil Konto aufgeladen.&nbsp;Die Einrichtung der monatlichen Aufladung erfolgt nach
              Erhalt Deiner SIM-Karte über die von Dir ausgewählte Zahlungsart.
            </p>
          </slot>
          </dyn-slot>
        </b-col>
      </b-row>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { stepName as topUpStep } from '../TopUp/EnterTopUpAndPayment.vue'
import price from '@/mixins/price'
import DynSlot from '@/components/generic/DynSlot.vue'

export default {
  name: 'ShowMonthly',
  props: {
    topUpInfo: {
      type: Object
    },
    changeBtn: {
      default: true
    }
  },
  computed: {
    slotData () {
      return {
        topUpInfoTrigger: this.topUpInfo.trigger
      }
    }
  },
  methods: {
    goToTopUpStep: function () {
      this.goToStep(topUpStep)
    },
    ...mapMutations('activation', [
      'goToStep'
    ])
  },
  mixins: [
    price
  ],
  components: { DynSlot }
}
</script>
